package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * − n + quantity stepper (Stitch product/cart screens). Caller owns the value; the component clamps
 * nothing — pass [min]/[max] to bound it. No copy inside (numbers only), so nothing to localize.
 */
@Composable
fun QuantityStepper(
    quantity: Int,
    onQuantityChange: (Int) -> Unit,
    modifier: Modifier = Modifier,
    min: Int = 1,
    max: Int = 99,
) {
    Row(modifier = modifier, verticalAlignment = Alignment.CenterVertically) {
        StepButton(icon = "remove", enabled = quantity > min) { onQuantityChange(quantity - 1) }
        Text(
            text = quantity.toString(),
            style = AppTheme.typography.bodyLg,
            color = AppTheme.colors.onSurface,
            textAlign = TextAlign.Center,
            modifier = Modifier.widthIn(min = AppTheme.sizes.iconLg),
        )
        StepButton(icon = "add", enabled = quantity < max) { onQuantityChange(quantity + 1) }
    }
}

@Composable
private fun StepButton(icon: String, enabled: Boolean, onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .size(AppTheme.sizes.iconLg)
            .clip(AppTheme.shapes.pill)
            .background(if (enabled) AppTheme.colors.surfaceContainer else AppTheme.colors.surfaceContainerHigh)
            .clickable(enabled = enabled, onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        AppIcon(
            name = icon,
            size = AppTheme.sizes.iconSm,
            tint = if (enabled) AppTheme.colors.onSurface else AppTheme.colors.onSurfaceVariant,
        )
    }
}
